import { OfferGeoField } from '../models';

export const offerGeoLabels = {
  [OfferGeoField.Bid]: 'Bid',
  [OfferGeoField.Ecpm]: 'RBid',
  [OfferGeoField.Koef]: 'Koef',
  [OfferGeoField.AutoBid]: 'Auto bid',
  [OfferGeoField.CntLimit]: 'Cnt limit',
  [OfferGeoField.DayCntLimit]: 'Day cnt limit',
  [OfferGeoField.SumLimit]: 'Sum limit',
  [OfferGeoField.DaySumLimit]: 'Day sum limit',
  [OfferGeoField.Url]: 'Url',
  [OfferGeoField.Geo]: 'Country',
  [OfferGeoField.Offer]: 'Offer',
  [OfferGeoField.CreatedBy]: 'Created by',
};
